export class OvervakningTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        title: "Övervakning",
        autoRefresh: "Uppdatera varje minut"
    };
}
